/*
 *
 * Api reducer
 *
 */

import produce from 'immer';
import _ from 'lodash';
import {
  TOGGLE_FULL_WIDTH,
  UI_SIDE_NAV_ATTACHED,
  UI_TOGGLE,
  UI_SIDE_LIST_ATTACHED,
  UI_WINDOW_RESIZE,
  LAYOUT_BREAK_SMALL,
  UI_TOP_MENU_TOGGLE,
} from './constants';

export const initialState = {
  UI: {
    fullWidth: {},
    scrollPosition: 0,
    window_width: window.innerWidth,
    window_height: window.innerHeight,
    isSmall: window.innerWidth <= LAYOUT_BREAK_SMALL,
    toggles: {
      [UI_SIDE_NAV_ATTACHED]: true,
      [UI_SIDE_LIST_ATTACHED]: true,
      [UI_TOP_MENU_TOGGLE]: true,
    },
  },
};

export const appReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case TOGGLE_FULL_WIDTH:
        if (action.toggle) draft.UI.fullWidth[action.id] = true;
        else delete draft.UI.fullWidth[action.id];
        break;
      case UI_TOGGLE:
        draft.UI.toggles[action.name] =
          action.value === undefined
            ? !draft.UI.toggles[action.name]
            : action.value;
        break;
      case UI_WINDOW_RESIZE:
        draft.UI.window_width = window.innerWidth;
        draft.UI.window_height = window.innerHeight;
        draft.UI.isSmall = window.innerWidth <= LAYOUT_BREAK_SMALL;
        break;
    }
  });
